import styled, { css } from 'styled-components';

import BusinessLogo from 'ggApp/shared/icons/BusinessLogo'
import GroverLogo from 'ggApp/shared/icons/GroverLogo';
import NavigationLink from 'ggApp/shared/common/NavigationLink';

const baseLinkStyle = css`
    height: 40px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        height: 32px;
    `};

    svg {
        height: 100%;
    }
`;

const Wrap = styled(NavigationLink)`
    ${baseLinkStyle}
`;

const RootLink = styled.a`
    ${baseLinkStyle};
    display: block;
`;

const StandardLogo = styled(GroverLogo)`
    min-width: 100px;
    outline: none;
`;

const BLogo = styled(BusinessLogo)`
    min-width: 140px;
`;

export {
    Wrap,
    StandardLogo,
    BLogo,
    RootLink
};
